import { useState } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import "./plansDialog.css";
import Price from "../../price/Price";
import IntervalsMenuPaymentPeriod from "../../intervalsMenuPaymentPeriod/IntervalsMenuPaymentPeriod";
import { walletShort } from "../../common/dataShort";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";

export default function PlansDialog(props) {
  const walletAbbr = useSelector((state) => state.settings.walletAbbr);

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleCloseAddWallet = () => {
    if (!props.userAuthWallet) {
      toast.error("First connect the wallet!");
      return;
    }

    if (!props.paidWallet) {
      toast.error("Wallet address is not defined!");
      return;
    }

    // Axios.post(process.env.REACT_APP_CRUD_SRV + "/wallet/add", {
    //   walletAddress,
    //   walletName,
    //   auth: props.userAuthWallet,
    //   cs: sha256(
    //     walletAddress + props.userAuthWallet + process.env.REACT_APP_SECRET
    //   ).toString(),
    // }).then((r) => {
    //   if (r.data?.status == 200) {
    //     console.log("Wallet " + walletAddress + " has been added.");
    //     props.getWallets();
    //   } else toast.error("Walet add error. Please wait for some time and try again.");
    // });

    props.setOpen(false);
  };

  //   const [walletAddress, setWalletAddress] = useState("");

  //   function handleWalletAddressChange(evt) {
  //     setWalletAddress(evt.target.value);
  //   }

  //   const [walletName, setWalletName] = useState("");

  //   function handleWalletNameChange(evt) {
  //     setWalletName(evt.target.value);
  //   }

  function priceByPlanMo(plan, mo) {
    return props.plans[plan] !== undefined &&
      props.plans[plan][mo] !== undefined
      ? props.plans[plan][mo]
      : 0;
  }

  return (
    <div className="paidPlansDialog">
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle className="paidPlansTitle">
          Activation of{" "}
          {walletAbbr && props.paidWallet
            ? walletShort(props.paidWallet)
            : props.paidWallet}
        </DialogTitle>
        <DialogContent>
          <p className="topP">
            To start tracking the wallet click Activate next to the plan that
            suits you.
          </p>

          <IntervalsMenuPaymentPeriod
            paymentPeriod={props.paymentPeriod}
            setPaymentPeriod={props.setPaymentPeriod}
          />

          <div className="paidPlans">
            <div className="price">
              <div className="planTitle">Basic</div>
              <p>Initial choice</p>
              <ul>
                <li>3 hour intervals</li>
                <li>1 month of history</li>
              </ul>

              <div className="priceRow">
                <span className="pricePerInterval" style={{ marginRight: 60 }}>
                  Free
                </span>
              </div>
              {/* {props.paymentPeriod == "Monthly" ? (
                <Price
                  price={
                    priceByPlanMo('Basic', 1)
                  }
                />
              ) : (
                <Price
                  price={
                    priceByPlanMo('Basic', 12).toFixed(2)
                  }
                  annualDiscount={
                    (priceByPlanMo('Basic', 1) * 3).toFixed(2)
                  }
                />
              )} */}
              {/* <Button
                variant="contained"
                className="addAdditionalWallet"
                onClick={() =>
                  props.handlePlanUpgrade(props.paidWallet, "Basic", "plans")
                }
              >
                Activate
                <br />
                Basic+
              </Button> */}
              {/* <div className="benefitsTitle">Package parameters:</div> */}
            </div>

            <div className="price">
              <div className="planTitle">Pro</div>

              <p>Optimal choice</p>

              <ul>
                <li>1 hour intervals</li>
                <li>3 years of history</li>
              </ul>

              {props.paymentPeriod == "Monthly" ? (
                <Price price={priceByPlanMo("Pro", 1)} />
              ) : (
                <Price
                  price={priceByPlanMo("Pro", 12)}
                  annualDiscount={(priceByPlanMo("Pro", 1) * 3).toFixed(2)}
                />
              )}
              <Button
                variant="contained"
                className="addAdditionalWallet"
                onClick={() =>
                  props.handlePlanUpgrade(props.paidWallet, "Pro", "plans")
                }
              >
                Activate
                <br />
                Pro+
              </Button>

              {/* <div className="benefitsTitle">All the benefits of Pro+:</div> */}
            </div>

            <div className="price">
              <div className="planTitle">Premium</div>

              <p>Highest precision and maximum data</p>

              <ul>
                <li>15 min intervals</li>
                <li>Whole time history</li>
              </ul>

              {props.paymentPeriod == "Monthly" ? (
                <Price price={priceByPlanMo("Premium", 1)} />
              ) : (
                <Price
                  price={priceByPlanMo("Premium", 12)}
                  annualDiscount={(priceByPlanMo("Premium", 1) * 3).toFixed(2)}
                />
              )}
              <Button
                variant="contained"
                className="addAdditionalWallet"
                onClick={() =>
                  props.handlePlanUpgrade(props.paidWallet, "Premium", "plans")
                }
              >
                Activate Premium+
              </Button>

              {/* <div className="benefitsTitle">
                    The complete package, with:
                  </div> */}
            </div>

            {/* <tr>
                <th></th>
                <th>Package parameters:</th>
                <th>All the benefits of Pro+:</th>
                <th>The complete package, with:</th>
              </tr> */}

            {/* <tr className="rowTitle">
                <td>
                  Interval{" "}
                  <Tooltip
                    className="help"
                    title="Time between automatic data collection"
                  >
                    <span>?</span>
                  </Tooltip>
                </td>
                <td>3 hours</td>
                <td>1 hour</td>
                <td>15 minutes</td>
              </tr>
              <tr className="rowTitle">
                <td>
                  History{" "}
                  <Tooltip
                    className="help"
                    title="History data shown on charts"
                  >
                    <span>?</span>
                  </Tooltip>
                </td>
                <td>Last month</td>
                <td>1 year</td>
                <td>3 years</td>
              </tr> */}

            {/* <tr>
            <td>
              Price for Unauthorized Wallets{" "}
              <span
                className="help"
                title="That do not require a wallet connection via Metamask"
              >
                ?
              </span>
            </td>
            <th className="price">
              $59/mo
              <div className="annualPrice">
                <label>$708</label> $597/yr
              </div>
            </th>
            <th className="price">
              $197/mo
              <div className="annualPrice">
                <label>$2364</label> $1397/yr
              </div>
            </th>
            <th className="price">
              $397/mo
              <div className="annualPrice">
                <label>$4764</label> $3797/yr
              </div>
            </th>
          </tr> */}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>I'll do it later</Button>
          {/* <Button onClick={handleCloseAddWallet}>Add Additional Wallet</Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
